import { render, staticRenderFns } from "./PortfolioTableHeaderCell.vue?vue&type=template&id=8227f8a8&scoped=true&"
import script from "./PortfolioTableHeaderCell.vue?vue&type=script&lang=ts&"
export * from "./PortfolioTableHeaderCell.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioTableHeaderCell.vue?vue&type=style&index=0&id=8227f8a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8227f8a8",
  null
  
)

export default component.exports